export const ROUTES = {
  HOME: '/',
  BANK_ACCOUNT_CONFIG: '/bank-account-config',
  BANK_ACCOUNT_CONFIG_UNAUTHORIZED: '/bank-account-config-unauthorized',
  TRANSFER: '/transfer',
  CONFIG: '/config',
  IDENTITY_VALIDATION: '/id-validation',
  TRANSACTION_DETAILS: '/transactions',
  PAYMENT_LINK: '/payment-link',
  PAYMENT_LINK_FORM: '/payment-link-create',
  PAYMENT_LINK_DETAILS: '/payment-link-details',
  LANDING: '/landing',
  INSTALLMENTS: '/installments',
  WITHDRAWS: '/withdraws',
  REFUND: '/refund',
  ORDER_REFUND: '/order-refund',
  PAYMENT_LINK_REFUND: '/payment-link-refund',
  SETTLEMENT_PERIOD: '/settlement-period',
  PAYMENT_METHODS: '/payment-methods',
  DASHBOARD: '/dashboard',
  TRANSFER_SUCCESS: '/transfer/success',
  REFUND_RECEIPT: '/refund-receipt',
  FUTURE_INCOME: '/future-incomes',
  LENDING_PAYMENT: '/lending/payment',
  LIVENESS_VALIDATION: '/liveness/check',
  TRANSACTIONS_REPORT: '/transactions-report',
  IDENTITY: '/identity',
  IDENTITY_FINANCIAL_INFO: '/identity/financial-info',
  BANKING_IDENTITY_VALIDATION: '/banking/identity-validation',
  BAKING_IDENTITY_VALIDATION_RESEND_DOCUMENT: '/banking/resend-documents',
  IDENTITY_VALIDATION_STEPS: '/identity-validation-steps',
  ONBOARDING: '/onboarding',
  PROVIDER_CONFIGURATIONS: '/settings',
  WITHDRAWS_CONFIG: '/withdraws-config',
  CHARGEBACK: '/chargeback-upload',
  AVAILABLE_BALANCE: '/statement/available',
  FUTURE_TRANSACTIONS: '/statement/future-transactions',
  EXPORT_REPORT: '/statement/export',
};

export const ADMIN_ROUTES = {
  PRODUCTS: '/products',
  PASSWORD_PROTECTED: '/themes/password-protected',
  PAYMENT_METHODS: '/settings/payments',
  NUVEMPAGO_PAYMENT_METHODS: '/settings/payments/nuvempago',
  ORDERS_AUTO_CANCEL: '/orders/auto-cancel',
};

export const SUPPORT_EMAIL = 'hola@tiendanube.com';
